import { render } from "./QuestionGroupTable.vue?vue&type=template&id=47beab0e"
import script from "./QuestionGroupTable.vue?vue&type=script&lang=js"
export * from "./QuestionGroupTable.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__